<template>
<div id="surveyEditorContainer">
    <editor-nav :content="navData" v-model="navSelection"></editor-nav>
    <div v-if="loggedIn" id="editorViewContainer"></div>
</div>
</template>

<script>
import auth from '@/auth'
import * as SurveyEditor from 'surveyjs-editor'
import * as SurveyKo from "survey-knockout";
import EditorNav from '../components/EditorNav'

import 'surveyjs-editor/surveyeditor.css'
// Survey.StylesManager.applyTheme("bootstrapmaterial");

// SURVEY MODEL PROPS DECLARED
SurveyKo.JsonObject.metaData.addProperty("survey", { name: "color:string", default: "" })
SurveyKo.JsonObject.metaData.addProperty("page", { name: "pageClass:string", default: "" })
SurveyKo.JsonObject.metaData.addProperty("question", { name: "specialClass:string", default: "" })
SurveyKo.JsonObject.metaData.addProperty("text", { name: "upperChoice:string", default: "Upper choice" })
SurveyKo.JsonObject.metaData.addProperty("text", { name: "lowerChoice:string", default: "Lower choice" })
// PAGE PROPS
let pageDefinition = SurveyEditor.SurveyQuestionEditorDefinition.definition["page"]
if (pageDefinition.properties[pageDefinition.properties.length-1].name != "pageClass") {
    pageDefinition.properties.push({
        name: "pageClass",
        title: "Page Class"
    })
}
// SURVEY PROPS
let surveyDefinition = SurveyEditor.SurveyQuestionEditorDefinition.definition["survey"]
if (surveyDefinition.properties[surveyDefinition.properties.length-1].name != "color") {
    surveyDefinition.properties.push({
        name: "color",
        title: "Color"
    })
}
// QUESTION PROPS
let questionDefinition = SurveyEditor.SurveyQuestionEditorDefinition.definition["question"]
questionDefinition.tabs = questionDefinition.tabs.filter(function (tab) { return tab.name !== 'visibleIf' })
questionDefinition.properties = [{
            name: "title",
            title: "Question"
        },{
            name: "name",
            title: "Identifiier"
        }, {
            name: "specialClass",
            title: "Special Class"
        }, {
            name: "visible",
            category: "checks"
        }, {
            name: "isRequired",
            category: "checks"
        }]
// TEXT PROPS
let textDefinition = SurveyEditor.SurveyQuestionEditorDefinition.definition["text"]
textDefinition.tabs = [{ name: "Vertical Slider", index: 12 }]
textDefinition.properties = [
    "inputType",
    "placeHolder", {
        name: "upperChoice",
        title: "Upper Choice",
        tab: "Vertical Slider"
    }, {
        name: "lowerChoice",
        title: "Lower Choice",
        tab: "Vertical Slider"
    }]
/*
import * as widgets from "surveyjs-widgets"
import "inputmask/dist/inputmask/phone-codes/phone.js"

widgets.icheck(SurveyKo)
widgets.select2(SurveyKo)
widgets.inputmask(SurveyKo)
widgets.jquerybarrating(SurveyKo)
widgets.jqueryuidatepicker(SurveyKo)
widgets.select2tagbox(SurveyKo)
widgets.ckeditor(SurveyKo)
widgets.autocomplete(SurveyKo)
widgets.nouislider(SurveyKo)
widgets.bootstrapslider(SurveyKo)

For later perhaps
widgets.signaturepad(SurveyKo)
widgets.sortablejs(SurveyKo)
*/

export default {
    name: 'survey-editor',
    data () {
        return {
            navSelection: '',
            surveys: {},
            navData: null,
            editor: null,
            status: '',
            loggedIn: false
        }
    },
    components: {
        EditorNav
    },
    methods: {
        checkLogin() {
            if (auth.isAuth()) {
                console.log("EDITOR LOGIN")
                return true
            } else {
                console.log("NON-EDITOR")
                return false
            }
        },
        getSurveys() {
            this.$downloadSurveys().then((res) => {
                // Convert Survey obj to a string model and load in the editor
                this.surveys = res
            })
        },
        loadEditor() {
            console.log("LOAD EDITOR")
            

            // ----------------------------------------------------------
            // CREATE EDITOR
            //
            let editorOptions = {
                showEmbededSurveyTab: true,
                haveCommercialLicense: true,
                // isAutoSave: true,
                // Limit editor toolbox to relevant question types for Ikigai
                questionTypes: ["text", "checkbox", "radiogroup", "dropdown", "boolean", "html", "matrix", "matrixdropdown"],
            }
            this.editor = new SurveyEditor.SurveyEditor('editorViewContainer', editorOptions)

            // Add custom features to the Toolbox
            this.editor.toolbox.addItem({
                name: "verticalSlider",
                isCopied: false,
                iconName: "icon-nouislider",
                title: "Vertical Slider",
                json: {
                    title: "Which sounds more like you?",
                    type: "text",
                    inputType: "range",
                    specialClass: "Vertical Slider",
                    optionsCaption: "Select a country...",
                }
            })
            this.editor.toolbox.addItem({
                name: "cardPicker",
                isCopied: false,
                iconName: "icon-radiogroup",
                title: "Card Picker",
                json: {
                    title: "Which sounds more like you?",
                    type: "radiogroup",
                    description: "Tap the card that you agree with most.",
                    specialClass: "Card Picker",
                    choices: [{
                        value:"L",
                        text:"Left choice"
                    },{
                        value:"R",
                        text:"Right choice"
                    }]
                }
            })
            this.editor.saveSurveyFunc = () => {
                // Convert text model to JSON object
                let model = JSON.parse(this.editor.text)
                // Update local model
                this.surveys[model.title] = model
                // Upload to DB
                this.$updateSurvey(model)
            }
            // Simplify the property lists in the editor
            let myBlackList = ["maxTimeToFinish", "indent", "correctAnswer", "enableIf", "width", "maxLength", "titleLocation"]
            this.editor.onCanShowProperty.add((sender, options) => {
                options.canShow = myBlackList.indexOf(options.property.name) < 0
            })

            // ----------------------------------------------------------
            // LOAD SURVEY FROM DB
            //
            this.getSurveys()
        }
    },
    watch: {
        authenticated(val) {
            this.loggedIn = val
            console.log("SE PAGE AUTH: "+this.loggedIn);
            if (this.loggedIn) {
                this.$nextTick(() => {
                    this.loadEditor()
                })
            } else {
                this.surveys = {}
                this.editor = null
            }
        },
        surveys(val) {
            let arr = []
            if (val) {
                arr = Object.keys(val)
            }
            arr.push('New survey')
            let status = {
                loggedIn: this.loggedIn,
                surveyList: arr
            }
            this.navData = status
        },
        navSelection(selection) {
            console.log("LOAD: "+selection);
            // Once survey has been selected load it
            if (selection == 'New survey') {
                console.log("NEW SURVEY")
                let survey = {}
                survey.title = "New Survey"
                survey.pagePrevText = "Back"
                survey.questionTitleTemplate = "{title} {require}"
                survey.showQuestionNumbers = "off"
                survey.showTitle = false
                this.editor.text = JSON.stringify(survey)
            }
            else if (selection != '') {
                console.log(this.surveys);
                this.editor.text = JSON.stringify( this.surveys[selection] )
            }
        }
    },
    mounted () {
        this.loggedIn = this.checkLogin()
        console.log("SURVEY EDITOR: "+this.loggedIn)
        this.$nextTick(() => {
            if (this.loggedIn) {

                // ----------------------------------------------------------
                // LOAD EDITOR
                //
                this.loadEditor()
            }
        })
    }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";
#surveyEditorContainer /deep/ {
    @import "../styles/bootstrap.min";
    height: 100vh;
    background-color: $color-adminWhite;
    .svd-light-bg-color {
        background-color: $color-adminWhite !important;
    }
    // Some bug with Glyphicons
    .glyphicon-edit {
        font-family: inherit;
        &:before {
            content: none;
        }
    }
    .navbar-default {
        border: none;
        padding-left: 24px;
    }
    .panel.svd_content {
        background-color: $color-darkCream !important;
        border: none;
        border-radius: 0;
        box-shadow: none;
        margin-top: -1px;
    }
    .svd_container .nav-item {
        border: none;
        font-family: "Roboto";
        .nav-link {
            color: $color-dark;
            font-weight: 400;
            padding-left: 20px;
            padding-right: 20px;
        }
    }
    .svd_container .nav-item.active .nav-link {
        background-color: $color-darkCream !important;
        border: none;
        color: $color-dark;
    }
    .svd-dark-bg-color {
        background-color: $color-darkCream !important;
        color: $color-dark;
        font-family: "Roboto";
        font-weight: 400;
        .svd-svg-icon {
            fill: $color-dark !important;
        }
    }
    .svd_container.svd_container.sv_bootstrap_css .svd-main-background-color {
        background-color: $color-dark;
    }
    .svd_toolbox_item {
        border-color: $color-darkerCream !important;
        .svd-svg-icon {
            fill: $color-dark !important;
        }
        &:hover {
            background-color: $color-adminWhite;
        }
    }
    .svd_editors {
        button {
            background-color: $color-dark !important;
            border: none;
        }
        .svd-svg-icon {
            fill: $color-dark !important;
        }
    }
    .svd_container.svd_container.sv_bootstrap_css .svd_custom_select::before, .svd_container .svd_custom_select:before {
        background-color: $color-dark;
    }
}

</style>

